<template>
    <v-container class="container-view mx-auto">
        <v-row class="d-flex justify-center white--text">
            <h1>Planillas</h1>
        </v-row>
        <v-row class="d-flex justify-center">
            <table class="table-filters" width="100%">
                <tbody>
                    <tr>
                        <td width="20%">
                            Elecciones
                        </td>
                        <td width="80%">
                            <v-select
                                v-model="electionIdSelected"
                                :item-text="textItemElection"
                                :items="elecciones"
                                :loading="loading"
                                item-value="id"
                                label="Selecciona elección"
                                @change="onChangeElection"
                            >
                            </v-select>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Centros / SEMS
                        </td>
                        <td>
                            <v-select
                                v-model="centerSelected"
                                :item-text="textItemCenter"
                                :items="centers"
                                :loading="loading"
                                item-value="centro"
                                label="Selecciona centro / SEMS"
                                @change="onChangeCenter"
                            >
                            </v-select>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Divisiones / Escuelas
                        </td>
                        <td>
                            <v-autocomplete
                                v-model="uresSelected"
                                :disabled="uresList.length === 0"
                                :item-text="textItemUres"
                                :items="uresList"
                                :loading="loading"
                                item-value="ures_pred"
                                label="Selecciona División / Escuela"
                                @change="onChangeUres"
                            >
                            </v-autocomplete>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Mesas
                        </td>
                        <td>
                            <v-select
                                v-model="tableSelected"
                                :disabled="tables.length === 0"
                                :items="tables"
                                :loading="loading"
                                chips
                                item-text="mesa"
                                item-value="mesa"
                                multiple
                                persistent-hint
                                @change="onChangeTable"
                            >
                            </v-select>
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>
                            <v-btn
                                :disabled="!electionIdSelected"
                                elevation="2"
                                small
                                style="pading: 10px 0px;"
                                @click="downloadCSV"
                                >Descargar Planillas
                            </v-btn>
                            <br />
                            <small
                                >Descargar todos las planillas del sistema por
                                elección (CSV)
                            </small>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="prp-table-container">
                <scale-loader
                    v-if="loading"
                    class="prp-table-loader"
                    color="black"
                ></scale-loader>
                <v-text-field
                    v-model="search"
                    hide-details
                    label="Buscar"
                    single-line
                >
                    <i slot="append" class="fa fa-search"></i>
                </v-text-field>
                <v-data-table
                    :headers="headers"
                    :items="list"
                    :items-per-page="25"
                    :search="search"
                    class="elevation-1"
                >
                    <template v-slot:item.candidates="{ item }">
                        <div
                            v-for="(candidate, index) in item.candidates"
                            :key="
                                index +
                                    candidate.nombre +
                                    candidate.clase_funcionario
                            "
                        >
                            <small
                                >{{ candidate.nombre }}
                                {{ candidate.clase_funcionario }}
                                {{ candidate.no_integrante }}</small
                            >
                            <hr />
                        </div>
                    </template>
                </v-data-table>
            </div>
        </v-row>
    </v-container>
</template>

<script>
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue';
import { mapGetters } from 'vuex';
import FileDownload from 'js-file-download';
import { DateTime } from 'luxon';

export default {
    name: 'planillas',
    components: {
        ScaleLoader,
    },
    computed: {
        ...mapGetters({
            elecciones: 'elecciones/elecciones',
        }),
    },
    data: () => {
        return {
            loading: false,
            series: [],
            uresList: [],
            centers: [],
            tables: [],
            electionIdSelected: '',
            centerSelected: '',
            uresSelected: '',
            tableSelected: [],
            list: [],
            search: '',
            headers: [
                {
                    text: 'Eleccion',
                    value: 'desc_eleccion',
                },
                {
                    text: 'Ures',
                    value: 'ures',
                },
                {
                    text: 'Desc Ures',
                    value: 'desc_ures',
                },
                {
                    text: 'Mesa',
                    value: 'mesa',
                },
                {
                    text: 'Ocg',
                    value: 'ocg',
                },
                {
                    text: 'Desc Ocg',
                    value: 'desc_ocg',
                },
                {
                    text: 'Id Planilla',
                    value: 'id_planilla',
                },
                {
                    text: 'Color',
                    value: 'color',
                },
                {
                    text: 'Candidatos',
                    value: 'candidates',
                },
            ],
        };
    },
    methods: {
        onChangeElection: function() {
            this.uresList = [];
            this.uresSelected = '';
            if (this.electionIdSelected) {
                this.loadCenters();
                this.loadUres();
                this.loadTables();
                this.generateTable();
            }
        },
        onChangeCenter: function() {
            this.uresList = [];
            this.uresSelected = '';
            this.loadUres();
            this.loadTables();
            this.generateTable();
        },
        onChangeUres: function() {
            if (!this.electionIdSelected) {
                return;
            }
            this.loadTables();
            this.generateTable();
        },
        onChangeTable: function() {
            this.generateTable();
        },
        loadCenters: function() {
            this.$store
                .dispatch('prep/getCenters', {
                    election_id: this.electionIdSelected,
                })
                .then(res => {
                    console.log(res);
                    if (res.length) {
                        res.unshift({
                            centro: '',
                            desc_centro: 'TODOS LOS CENTROS',
                        });
                    }
                    this.centers = res;
                });
        },
        loadUres: function() {
            this.$store
                .dispatch('prep/getUresByIdElection', {
                    election_id: this.electionIdSelected,
                    center_id: this.centerSelected,
                })
                .then(res => {
                    console.log(res);
                    if (res.length) {
                        res.unshift({
                            ures_pred: '',
                            desc_ures_pred: 'TODOS LOS URES',
                        });
                    }
                    this.uresList = res;
                });
        },
        loadTables: function() {
            this.tables = [];
            this.tableSelected = [];
            this.$store
                .dispatch('prep/getTables', {
                    election_id: this.electionIdSelected,
                    center_id: this.centerSelected,
                    ures: this.uresSelected,
                })
                .then(res => {
                    console.log(res);
                    if (res.length) {
                        this.tables = res;
                    }
                });
        },
        generateTable: function() {
            const filters = {
                election_id: this.electionIdSelected,
                center_id: this.centerSelected,
                ures: this.uresSelected,
                table_id: this.tableSelected == '' ? [] : this.tableSelected,
            };
            this.loading = true;
            this.$store
                .dispatch('prep/getPlanillas', filters)
                .then(res => {
                    console.log({ res });
                    this.list = res;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        downloadCSV: function() {
            this.$store
                .dispatch('prep/getPlanillasCSV', {
                    election_id: this.electionIdSelected,
                })
                .then(res => {
                    const eleccion = this.elecciones.find(
                        eleccion => eleccion.id === this.electionIdSelected
                    );

                    if (eleccion) {
                        const type =
                            eleccion.type.charAt(0).toUpperCase() +
                            eleccion.type.slice(1);
                        const fileName = `${
                            eleccion.id
                        }Planillas${type}-${DateTime.now().toFormat(
                            'dd-MM-yyyy'
                        )}`;
                        const data = new Blob([res.csv], { type: 'text/csv' });
                        FileDownload(data, fileName + '.csv');
                    }
                });
        },
        textItemElection: item =>
            `${item.id} - ${item.description} | ${item.type.toUpperCase()}`,
        textItemCenter: item =>
            item.desc_centro + (item.centro ? ' | ' + item.centro : ''),
        textItemUres: item =>
            item.desc_ures_pred +
            (item.ures_pred ? ' | ' + item.ures_pred : ''),
    },
    created() {
        this.$store.dispatch('elecciones/getElecciones');
    },
};
</script>

<style lang="scss">
.prp-container {
    padding: 1rem;
}

.prp-title {
    text-align: center;
    margin-bottom: 2rem;
}

.prp-home-back {
    cursor: pointer;
    position: absolute;
}

.prp-table-container {
    position: relative;
    border-radius: 0.5rem;
    margin-top: 1.5rem;
    padding: 1rem;
    width: 100%;
    background-color: $votex-gray-background;
}

.prp-table-loader {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.table-filters {
    background-color: #fff;
    border-collapse: collapse;
    padding: 1rem;
    border-radius: 0.5rem;

    tr:first-child td {
        border-top: 0;
    }

    tr td:first-child {
        border-left: 0;
    }

    tr:last-child td {
        border-bottom: 0;
    }

    tr td:last-child {
        border-right: 0;
    }

    td {
        border: 1px solid $votex-gray-background;
        color: $votex-background-primary;

        select {
            width: 100%;
        }
    }
}
</style>
